import { CheckIcon } from "@/components/appIcons";
import { FallbackImage } from "@/components/fallback-image";
import { AddToListsButton } from "@/components/lists/add-to-lists-button";
import { WishlistBadge } from "@/components/lists/wishlist-badge";
import type { AddToListsTarget } from "@/lib/add-to-lists-target";

export function AlbumCardImage({
  addToListsTarget,
  hideActions,
  imageSrcSet,
  imageSizes = "(min-width: 1280px) 16vw, (min-width: 1024px) 20vw, (min-width: 768px) 25vw, (min-width: 640px) 33vw, 50vw",
  imageUrl,
  inCollection,
  priority,
  title,
}: {
  addToListsTarget?: AddToListsTarget;
  hideActions: boolean;
  imageSrcSet: string | undefined;
  imageSizes?: string;
  imageUrl: string | null;
  inCollection: boolean;
  priority: boolean;
  title: string;
}) {
  return (
    <div className="relative aspect-square w-full overflow-hidden bg-secondary">
      <FallbackImage
        src={imageUrl}
        srcSet={imageSrcSet}
        alt={title}
        priority={priority}
        showLoadingSpinner
        sizes={imageSizes}
        className="transition duration-300 group-hover:scale-[1.03]"
      />
      {!hideActions && <WishlistBadge workId={addToListsTarget?.workId} />}
      {!hideActions && inCollection && (
        <div className="absolute top-2 right-2 z-20 size-7 rounded-full bg-green-600 text-white flex items-center justify-center shadow-lg ring-2 ring-white/80">
          <CheckIcon className="text-sm" style={{ fontSize: "16px" }} />
        </div>
      )}
      {!hideActions && addToListsTarget && (
        <div className="absolute bottom-2 right-2 z-20">
          <AddToListsButton
            target={addToListsTarget}
            variant="icon"
            className="size-9 after:-inset-1 bg-black/75 text-white shadow-lg ring-1 ring-white/70 backdrop-blur-sm transition-colors hover:bg-black/90"
          />
        </div>
      )}
    </div>
  );
}
